export default "__VITE_ASSET__DdG7sGk$__"